module.exports = __webpack_public_path__ + "img/phephani.0d6b1822.png";